import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";

const RichTextEditor = ({ content, setContent }) => {
  const handleChange = (value) => {
    setContent(value);
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
    "color",
    "background",
    "align",
  ];

  return (
    <div className="py-4 max-w-2xl mx-auto">
      <Card className="shadow-lg rounded-3">
        <Card.Body>
          <Card.Title className="mb-4">Rich Text Product Features</Card.Title>
          <ReactQuill
            value={content}
            onChange={handleChange}
            modules={modules}
            formats={formats}
            className="mb-4 rounded editor"
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default RichTextEditor;
